var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "label-width": "80px",
          "query-params": _vm.queryParams,
          selection: _vm.selection,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          afterFetchOriginalData: _vm.afterFetchOriginalData,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("screenWMS.basket"),
                          prop: "basketId",
                        },
                      },
                      [
                        _c("BjInputNumber", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("screenWMS.basket"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.basketId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "basketId", $$v)
                            },
                            expression: "queryParams.basketId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("screenWMS.lamp"),
                          prop: "lampIndex",
                        },
                      },
                      [
                        _c("BjInputNumber", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("screenWMS.lamp"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.lampIndex,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "lampIndex", $$v)
                            },
                            expression: "queryParams.lampIndex",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function (tableOperationProp) {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onAdd },
                      },
                      [_vm._v(_vm._s(_vm.$t("billingPage.create")))]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "delete-btn",
                        attrs: {
                          type: "primary",
                          disabled: tableOperationProp.notSelected,
                        },
                        on: { click: _vm.onDeleteSelected },
                      },
                      [_vm._v(_vm._s(_vm.$t("bulkDelText")))]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEdit(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("editText")))]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "delete-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDelete(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("delText")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("DataForm", { ref: "DataForm", on: { reFresh: _vm.reFresh } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }